<div [ngClass]="wrapperClasses">
    <a 
        [ngClass]="contentClasses"
        [attr.href]="href ? href : null"
        [attr.data-gtm-label]="gtmLabel"
        (click)="handleClick()"
        role="button"
        tabindex="0">

        
        <span [ngClass]="textClasses">
            <ng-content></ng-content>
        </span>

        <svg *ngIf="isDocument" 
             class="link-icon" 
             width="15" 
             height="18" 
             viewBox="0 0 15 18" 
             fill="none" 
             xmlns="http://www.w3.org/2000/svg">
            <path d="M4 14.5H11V13.5H4V14.5ZM4 10.5H11V9.5H4V10.5ZM2.11537 18C1.65512 18 1.27083 17.8458 0.9625 17.5375C0.654167 17.2292 0.5 16.8449 0.5 16.3846V1.61537C0.5 1.15512 0.654167 0.770833 0.9625 0.4625C1.27083 0.154167 1.65512 0 2.11537 0H10L14.5 4.5V16.3846C14.5 16.8449 14.3458 17.2292 14.0375 17.5375C13.7292 17.8458 13.3449 18 12.8846 18H2.11537ZM9.5 5V1H2.11537C1.96154 1 1.82052 1.0641 1.6923 1.1923C1.5641 1.32052 1.5 1.46154 1.5 1.61537V16.3846C1.5 16.5385 1.5641 16.6795 1.6923 16.8077C1.82052 16.9359 1.96154 17 2.11537 17H12.8846C13.0385 17 13.1795 16.9359 13.3077 16.8077C13.4359 16.6795 13.5 16.5385 13.5 16.3846V5H9.5Z" 
                  fill="currentColor"/>
        </svg>
    </a>
</div>